//    ***** CSS IMPORTS *******
import "react-toastify/dist/ReactToastify.css";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import "./assets/css/index.scss";
import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import Application from './ui';
import reportWebVitals from './report-web-vitals';
import {ApiExecutor} from "./@bizkeytech";
import ApiService from "./core/services/api";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
// noinspection ES6UnusedImports
import {} from './@bizkeytech/base/type-declerations';
import UIUtils from "./ui/utils";
import {registerPlugin} from "react-filepond";
import EnvService from "./core/services/env";
import {InternalAxiosRequestConfig} from "axios";


export const RootElement = document.getElementById('root') as HTMLElement;
export const ReactRoot = ReactDOM.createRoot(RootElement);

/**
 * The driver of the application.
 */
class Driver {

    /**
     * Runs the application.
     */
    public static run(): void {
        this.initializeScrollbar().then();
        this.initializeAPIServices();
        this.registerFilePondPlugins();
        this.render();
        this.reportWebVitals();
    }

    /**
     * Renders the application.
     * @private
     */
    private static render(): void {
        // STRICT MODE WILL INTENTIONALLY CALL USE_REDUCER AND USE_STATE's INITIAL METHODS MULTIPLE TIMES TO TEST THE PUTRIDITY OF SUCH
        //  FUNCTIONS. IT ALSO CHECKS FOR THE PROBLEMS IN CONCURRENT MODE SO THE PERFORMANCE IS INTENTIONALLY WORSE. PLEASE BE AWARE!!!
        // IF A DISPATCH OF A USE REDUCER THROWS, THE DISPATCHER AUTOMATICALLY RECALLS THE DISPATCH IN HOPE THAT THE ERROR IS RESOLVED
        ReactRoot.render(
            // <StrictMode>
            <Application/>
            // </StrictMode>
        );
    }

    /**
     * Initializes whether we need to force the webkit scrollbar or not.
     * @private
     */
    private static async initializeScrollbar() {
        await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
        // Exclude Edge which also includes 'Chrome' in UA
        const isChrome: boolean = /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);
        const chromeVersionArray: RegExpExecArray | null = /Chrome\/([0-9]+)/.exec(navigator.userAgent);
        const chromeVersion: number = chromeVersionArray ? parseInt(chromeVersionArray[1], 10) : 0;
        const isModernChrome: boolean = isChrome && chromeVersion >= 121;

        document.body.classList.toggle('force-webkit-scrollbar', isModernChrome);
    }

    /**
     * Initializes the api services and inject the effects that are used by the ApiService.
     */
    private static initializeAPIServices(): void {
        ApiService.executor = new ApiExecutor();

        const showToastsEffect = {id: 'showToastApiCallEffect', effect: UIUtils.showToastApiCallEffect.bind(UIUtils)}
        ApiService.injectEffects([showToastsEffect]);

        const cmsTokensHeaderInjector = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
            config.headers['Businesstoken'] = EnvService.CMSBusinessToken;
            config.headers['ApplicationToken'] = EnvService.CMSApplicationToken;
            return config;
        }
        ApiService.injectInterceptors({
            request: [[cmsTokensHeaderInjector]]
        })
    }

    /**
     * Registers the file pond plugins.
     */
    private static registerFilePondPlugins(): void {
        registerPlugin(
            FilePondPluginImageExifOrientation,
            FilePondPluginImagePreview,
            FilePondPluginFileValidateType,
        )
    }

    /**
     * Reports the web vitals.
     * @private
     */
    private static reportWebVitals(): void {
        reportWebVitals();
    }

}

Driver.run();
